import { Component, EventEmitter, Input, Output } from '@angular/core';
import { filter, first, mergeMap, tap } from 'rxjs/operators';
import { BaseComponent } from '../../../shared/base-components/base.component';
import { OwnershipCompositeServiceEnum } from '../../../titleregistration/models/enums/owership-composite.enum';
import { OwnershipRoleType } from '../../../titleregistration/models/enums/ownership-role-type.enum';
import { TitleRegistrationService } from '../../../titleregistration/services/titleregistration.service';
import { VehicleAddModalComponent, VehicleAddModalData } from '../../../vehicle/components/shared/vehicle/vehicle-add-modal/vehicle-add-modal.component';
import { VehicleService } from '../../../vehicle/services/vehicle.service';
import { MvdModalService } from '../../services/modal/mvd-modal.service';

@Component({
    selector: 'vehicle-search-bar',
    templateUrl: './vehicle-search-bar.html'
})
export class VehicleSearchBarComponent extends BaseComponent {
    @Input() label: string;
    @Input() placeholder = 'Search by: Plate, VIN, Short VIN, Permit or Title';
    @Input() readOnly: boolean;
    @Input() required = true;
    @Input() searchOnly = false;
    @Input() vehicleId: any;
    @Output() onItemRemoved: EventEmitter<any> = new EventEmitter();
    @Output() onItemSelected: EventEmitter<any> = new EventEmitter();

    public hasSearched = false;
    public vehicle: any;
    public validationMessage = '';
    private ownershipRoleType: OwnershipRoleType = new OwnershipRoleType();
    private searchString: string;

    constructor(
        private modalService: MvdModalService,
        private titleRegistrationService: TitleRegistrationService,
        private vehicleService: VehicleService
    ) {
        super();
    }

    ngOnInit() {
        if (this.vehicleId) {
            this.vehicleSelected(+this.vehicleId);
        }
    }

    addVehicle() {
        if (this.searchString) {
            const data = new VehicleAddModalData(null, this.searchString, false, 'Add New Vehicle', false);
            const dialogRef = this.modalService.open(VehicleAddModalComponent, data);
            dialogRef.afterClosed()
                .pipe(
                    filter(result => !!result),
                    mergeMap(acceptedValue => this.vehicleService.getVehicleComposite(acceptedValue)),
                    tap(result => result.vehicleId = result.id)
                )
                .subscribe(
                    result => this.vehicleSelected(result, false),
                    err => console.log(err)
                );
        }
    }

    getSearchString = (search: string): void => {
        this.searchString = search;
    };

    removeVehicle() {
        this.onItemRemoved.emit(this.vehicleId);

        this.vehicle = undefined;
        this.hasSearched = false;
    }

    searchCompleted(value: boolean) {
        if (!value) {
            this.vehicle = undefined;
            this.validationMessage = '';
        }

        this.hasSearched = value;
    }

    async vehicleSelected(data: any, shouldGetOwnership: boolean = true) {
        if (data && !Array.isArray(data)) {
            if (typeof data === 'object' && data !== null && !!data.vehicleId) {
                this.vehicle = data;
            } else if (Number.isInteger(data as number)) {
                this.vehicle = await this.vehicleService.getVehicleComposite(data).pipe(first()).toPromise();
                this.vehicle.vehicleId = this.vehicle.id;
            } else {
                return;
            }

            await this.getOwnershipInfo(shouldGetOwnership);
            this.onItemSelected.emit(this.vehicle);
        } else {
            this.validationMessage = data[0].errorMessage;
        }
    }

    private async getOwnershipInfo(shouldGetOwnership: boolean) {
        if (shouldGetOwnership) {
            const result = await this.titleRegistrationService.getActiveVehicleOwnership(this.vehicle.vehicleId, OwnershipCompositeServiceEnum.Title, OwnershipCompositeServiceEnum.Customer).pipe(first()).toPromise();
            if (result && Array.isArray(result.ownershipCustomerRelationships)) {
                this.vehicle.vehicleOwnershipId = result.id;
                this.vehicle.owner = result.ownershipCustomerRelationships.find(x => x.ownershipRoleTypeID == this.ownershipRoleType.Owner.id || x.ownershipRoleTypeID == this.ownershipRoleType.Lessee.id);
                this.vehicle.lienHolder = result.ownershipCustomerRelationships.find(x => x.ownershipRoleTypeID == this.ownershipRoleType.Lienholder.id);
                if (this.vehicle) {
                    if (this.vehicle.owner && this.vehicle.owner.customer) {
                        this.vehicle.ownerName = this.vehicle.owner.customer.customerName;
                    }
                    if (this.vehicle.lienHolder && this.vehicle.lienHolder.customer) {
                        this.vehicle.lienHolderName = this.vehicle.lienHolder.customer.customerName;
                    }
                }
            }
        }
    }
}
